var _ = require('lodash');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="weighted-interest-calculator"> <div class="individual-loans"> </div> <div class="interest-summary"> </div> </div>';
}
return __p;
};
